import React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import OptionDetails from '../views/optionDetails/OptionDetails';
import ScrollTop from './ScrollTop';
import { toggleOption } from '../store/actions';

class OptionsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onChange: props.onChange,
      onDetails: this.onDetails
    };
  }

  onDetails = option => {
    const { history, match } = this.props;
    const url = `${match.url}/option/${option.id}`;
    history.push(url);
  };

  onDetailsClose = () => {
    const { history, match } = this.props;
    history.push(match.url);
  };

  onDetailsSelect = option => {
    const { history, match, onChange } = this.props;
    history.push(match.url);
    onChange(option);
  };

  render() {
    const { children, options, match } = this.props;
    return (
      <ScrollTop>
        {children(this.state)}
        <Route
          path={`${match.url}/option/:id`}
          render={({ match }) => {
            const id = match.params.id;
            const option = options[id];
            return (
              <OptionDetails
                option={option}
                onClose={this.onDetailsClose}
                onSelect={() => this.onDetailsSelect(option)}
              />
            );
          }}
        />
      </ScrollTop>
    );
  }
}

const mapStateToProps = state => {
  return {
    options: state.config.options
  };
};

const mapDispatchToProps = dispatch => {
  const onChange = option => dispatch(toggleOption(option));

  return {
    onChange
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OptionsPage)
);
